import axios from 'axios';

// API Calls
export function isLoggedIn(ajax_url) {
  const send_data = 'action=ha_logged_in';
  axios.post(ajax_url, send_data).then(function (response) {
    if (response.data === 'yes') {
      return true;
    } else {
      return false;
    }
  });
}

// Get User ID
export const getUserID = (ajax_url) => {
  const send_data = "action=rb2_userID";
  const returnId = axios.post(ajax_url, send_data).then(function (response) {
    const userID = response.data;
    return userID;
  });
  return returnId;
};

// Sign Up
export function signUp(data, ajax_url, props, setformError, setLoading) {
  const loginName =
    data.email.split('@')[0] +
    data.email.split('@')[1].split('.')[0] +
    '-' +
    data.email.split('@')[1].split('.')[1];

  const send_data =
    'action=ha_signup&first_name=' +
    data.firstName +
    '&password=' +
    data.password +
    '&email=' +
    data.email +
    '&login_name=' +
    loginName;

  axios.post(ajax_url, send_data).then(function (response) {
    if (response.data === 'TRUE') {
      props.changeState('loggedIn', true);
      props.changeState('loaded', true);
      props.changeState('first_name', data.firstName);
      props.changeState('email', data.email);
      setLoading(false);
      props.scrollToAnalysis();
    } else {
      setformError(response.data);
      setLoading(false);
    }
  });
}

// Login
export function logIn(data, ajax_url, props, setformError, setLoading) {
  const login_send_data =
    'action=ha_login&username=' + data.email + '&password=' + data.password;

  axios.post(ajax_url, login_send_data).then(function (response) {
    if (response.data === 'TRUE') {
      props.changeState('loggedIn', true);
      props.changeState('loaded', true);
      props.changeState('email', data.email);
      setLoading(false);
      props.scrollToAnalysis();
    } else {
      setformError(
        'Error logging in. Be sure your username and password are correct.'
      );
      setLoading(false);
    }
  });
}

// Save To Database
export function saveDB(text, ajax_url) {
  const send_data = 'action=ha_db&text=' + text;

  axios.post(ajax_url, send_data).then(function (response) {
    if (response.data === 'TRUE') {
      console.log('Thank you for using HeadlineAnalyzer.io :)');
    } else {
      console.log('Error saving to database.');
    }
  });
}

export async function saveData(dataObj, ajax_url) {
  const dataString = Object.keys(dataObj).reduce((acc, key) => {
    return acc + `&${key}=${encodeURIComponent(dataObj[key])}`
  }, '')
  const send_data = 'action=ha_db' + dataString;

  axios.post(ajax_url, send_data).then(function (response) {
    if (response.data === 'TRUE') {
      console.log('Thank you for using HeadlineAnalyzer.io :)');
    } else {
      console.log('Error saving to database.');
    }
  });
}

// Load Words
export async function loadWordsDB(ajax_url) {
  const send_data = 'action=load_words';

  const result = await axios
    .post(ajax_url, send_data)
    .then(function (response) {
      return response.data;
    });

  return result;
}

export async function loadTitlesDB(ajax_url) {
  const send_data = 'action=fetch_job_titles';

  const result = await axios
    .post(ajax_url, send_data)
    .then(function (response) {
      return response.data;
    });

  const formattedResult = result
    .map(item => item.job_title.toLowerCase())
    .sort((a, b) => {
      return b.length - a.length;
    });

  console.log({ formattedResult });

  return formattedResult;
}

// Use Credits
export async function monetizationUseCredits(
  ajax_url,
  setMonetizationCredits,
  method,
  credits
) {
  const send_data =
    'action=use_credits&method=' + method + '&credits=' + credits + '';
  let returnData = [];
  const creditHtml = document.getElementsByClassName('jsUserCredits');
  let creditResponse = '';
  await axios.post(ajax_url, send_data).then(function (response) {
    creditResponse = response.data;
    console.log('creditResponse', creditResponse)
    if (creditResponse.action == 'limit') {
      const regDate = new Date(creditResponse.userRegDate);
      const curDate = new Date();
      const curMonthDays = new Date(curDate.getFullYear(), (curDate.getMonth()+1), 0).getDate();
      let refreshDate = regDate;
      refreshDate.setMonth(curDate.getMonth() + 1);
      console.log('refreshDate', refreshDate.getDate())
      console.log('curMonthDays', curMonthDays)
      console.log('curDate.getDate()', curDate.getDate())
      const refreshDaysVal = refreshDate.getDate() > curDate.getDate() ? refreshDate.getDate() - curDate.getDate() : (curMonthDays - curDate.getDate() + refreshDate.getDate());
      console.log('refreshDaysVal', refreshDaysVal)

      const refreshDays = document.getElementsByClassName('jsRefreshDays');
      for (let i = 0; i < refreshDays.length; i++) {
        // refreshDays[i].innerHTML = days + 1;
        refreshDays[i].innerHTML = refreshDaysVal + 1;
      }
      const creditLimitModal = document.getElementsByClassName('creditLimitModal');
      for (let i = 0; i < creditLimitModal.length; i++) {
        creditLimitModal[i].style.display = 'block';
      }
    } else if (creditResponse.action == 'free') {
      const mainHeader = document.getElementsByClassName('main-header');
      const creditAdditionalTooltip = document.getElementById('jsAdditionalCreditTooltip');
      for (let i = 0; i < mainHeader.length; i++) {
        mainHeader[i].classList.add('mobileStickyMenu');
      }
      for (let i = 0; i < creditHtml.length; i++) {
        creditHtml[i].innerHTML = 2;
      }
      creditAdditionalTooltip.classList.remove('d-none');
      if ((creditResponse.showAction && !creditResponse.creditUsage) || (creditResponse.showAction && creditResponse.creditUsage && !creditResponse.creditUsage.includes('mailscoop'))){
        const toolUsageResyBuild = document.getElementById('jsToolUsageHeadline');
        const toolUsageTooltip = document.getElementById('jsToolUsageTooltip');
        toolUsageResyBuild.classList.remove('d-none');
        toolUsageTooltip.classList.remove('d-none');
      }
    } else {
      for (let i = 0; i < creditHtml.length; i++) {
        creditHtml[i].innerHTML = creditResponse.credits;
      }
      if (creditResponse.firstAction == 1) {
        const firstActionModal = document.getElementsByClassName('firstActionModal');
        const firstActionToggleHide = document.getElementsByClassName('jsFirstActionToolToggle');
        const firstActionToggleShow = document.querySelectorAll('.jsFirstActionToolToggle[method="headlineanalyzer"], .jsFirstActionToolToggle[method="others"]');
        for (let i = 0; i < firstActionToggleHide.length; i++) {
          firstActionToggleHide[i].classList.add('d-none');
        }
        for (let i = 0; i < firstActionToggleShow.length; i++) {
          firstActionToggleShow[i].classList.remove('d-none');
        }
        for (let i = 0; i < firstActionModal.length; i++) {
          firstActionModal[i].style.display = 'block';
        }
      }else{
        if ((creditResponse.showAction && !creditResponse.creditUsage) || (creditResponse.showAction && creditResponse.creditUsage && !creditResponse.creditUsage.includes('mailscoop'))){
          const toolUsageResyBuild = document.getElementById('jsToolUsageHeadline');
          const toolUsageTooltip = document.getElementById('jsToolUsageTooltip');
          toolUsageResyBuild.classList.remove('d-none');
          toolUsageTooltip.classList.remove('d-none');
        }
      }
    }
    setMonetizationCredits(response.data);
    returnData = response.data;
    return response.data;
  });

  return returnData;
}
